import React, { useEffect, useState } from 'react';

import { confirmationSlice, toastSlice } from 'slices';
import i18n from 'translations';
import { useAppDispatch } from 'store/hooks';
import {
  IDealerOptionsWithTickets,
  IDealerTicket,
} from 'thunks/RTKQuery/dealer';
import { IDealerItem } from 'pages/Shared/Dealer/Models/dealers';
import { Confirmation } from 'components/Modal';
import { DealerDetailModelComponent } from './component';

interface IDealerDetailModel {
  show: boolean;
  title: string;
  assignTicketToNewDealer: (
    dealerTicketId: number,
    dealerId: string,
    ticket: string,
    oldDealerId?: string
  ) => void;
  dealerList: [IDealerOptionsWithTickets] | undefined;
  rowItem: IDealerTicket;
  onClose: () => any;
}

export const DealersDetailModal = ({
  show,
  title,
  assignTicketToNewDealer,
  dealerList,
  rowItem,
  onClose,
}: IDealerDetailModel) => {
  const dispatch = useAppDispatch();
  const [selectedDealer, setSelectedDealer] = useState<IDealerItem>();
  const [errorString, setErrorString] = useState('');

  useEffect(() => {
    if (rowItem.dealerTicketId && selectedDealer?.dealerId) {
      dispatch(
        confirmationSlice.actions.show({
          title: i18n.t('dealerManagement.updateTicketDealerConfirm.title'),
          message: i18n.t('dealerManagement.updateTicketDealerConfirm.message'),
          buttonOk: i18n.t(
            'dealerManagement.updateTicketDealerConfirm.buttonOk'
          ),
          buttonCancel: i18n.t(
            'dealerManagement.updateTicketDealerConfirm.buttonCancel'
          ),
          callback: async () => {
            dispatch(confirmationSlice.actions.close());
            assignTicketToNewDealer(
              rowItem.dealerTicketId,
              selectedDealer.dealerId,
              rowItem.ticketId,
              rowItem.dealerId
            );
            setSelectedDealer(undefined);
            onClose();
          },
        })
      );
    }
  }, [selectedDealer]);

  useEffect(() => {
    if (errorString !== '') {
      dispatch(
        toastSlice.actions.show({
          title,
          message: errorString,
        })
      );
    }
    setErrorString('');
  }, [errorString]);

  return (
    <>
      <DealerDetailModelComponent
        show={show}
        title={title}
        setSelectedDealer={setSelectedDealer}
        dealerData={
          (dealerList?.map((dealer) => ({
            id: dealer.id,
            dealerId: dealer.dealerId,
            name: dealer.dealerName,
          })) as unknown) as IDealerItem[]
        }
        onClose={() => {
          setSelectedDealer(undefined);
          onClose();
        }}
        setErrorString={setErrorString}
        assignedDealerId={rowItem.dealerId}
      />
      <Confirmation />
    </>
  );
};

DealersDetailModal.defaultProps = {};
